<div class="main-header">
  <div class="px-2">
    <nav
      class="navbar navbar-expand-lg navbar-light d-flex align-items-center justify-content-between"
    >
      <!-- Logo -->
      <div class="d-flex align-items-center gap-0">
        <a class="navbar-brand d-flex align-items-center mr-3" [routerLink]="APP_ROUTES.GUEST.ROOT">
          <img [src]="ASSETS.logo" alt="Company Logo" class="main-header__logo" />
        </a>
        @if(accessDashboard) {
        <div class="main-header-icon-content">
          <div class="dropdown">
            <button
              class="profile-icon btn btn-link"
              type="button"
              id="quickActionsMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style="border: none; background: none; box-shadow: none; padding: 0; margin: 0"
            >
              <i class="bi bi-grid text-black" style="font-size: 20px"></i>
            </button>
            <ul
              class="dropdown-menu quick-actions dropdown-menu-start"
              aria-labelledby="quickActionsMenuButton"
            >
              @for (item of filteredLeftMenuItems; track item.label) {
              <li class="nav-item">
                <a
                  class="dropdown-item quick-actions"
                  [routerLink]="item.routerLink"
                  [routerLinkActive]="['active']"
                >
                  <i [class]="item.icon"></i>
                  <span>{{ item.label }}</span>
                </a>
              </li>
              }
            </ul>
          </div>
          <div
            class="border-left border-secondary-100"
            style="height: 20px; padding-left: 10px; margin-left: 10px"
          ></div>

          <!-- Home Icon in mobile view done -->
          <div class="nav-item">
            <a
              [routerLink]="routeLink.dashboard"
              class="nav-item__link"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <i class="fa-solid fa-house nav-item__home-icon"></i>
              <span>Home</span></a
            >
          </div>
        </div>
        }
      </div>
      @if (userProfile) {
      <div class="justify-content-end d-flex align-items-center">
        <ul class="main-header-actions">
          <!-- @if(subscribed) {
          <li class="nav-item">
            <a
              [routerLink]="routeLink.upgrade"
              class="upgrade-button"
              [routerLinkActive]="['active']"
            >
              <i class="bi bi-gem me-1"></i>
              Upgrade</a
            >
          </li>
          } -->
          <!-- <li class="nav-item" [routerLink]="routeLink.helpCenter" [routerLinkActive]="['active']">
            <i class="fa-regular fa-circle-question menu-header__icon"></i>
          </li>
          <li class="nav-item">
            <i class="fa-regular fa-bell menu-header__icon"></i>
          </li> -->
          <li class="nav-item">
            <div class="menu-item-profile">
              <div class="dropdown">
                <button
                  class="profile-icon-button btn btn-link"
                  type="button"
                  id="profileMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  @if(userProfile.profilePicturePath) {
                  <img
                    [src]="getImageUrlWithCacheBust(userProfile.profilePicturePath)"
                    alt="Profile"
                    class="profile-icon"
                  />
                  } @else {
                  <label class="profile-icon">
                    {{ userProfile.firstName.charAt(0) | uppercase 
                    }}{{ userProfile.lastName.charAt(0) | uppercase }}
                  </label>
                  }
                </button>
                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileMenuButton">
                  <!-- Profile Info (does NOT close on click) -->
                  <li class="px-3 py-2 profile-item" (click)="$event.stopPropagation()">
                    <div class="profile-dev">
                      @if(userProfile.profilePicturePath) {
                      <img
                        [src]="userProfile.profilePicturePath"
                        alt="Profile"
                        class="profile-icon"
                      />
                      } @else {
                      <label class="profile-icon">
                        {{ userProfile.firstName.charAt(0) | uppercase }}{{ userProfile.lastName.charAt(0) | uppercase }}
                      </label>
                      }
                      <div>
                        <p class="profile-name">
                          {{ userProfile.firstName }} {{ userProfile.lastName }}
                        </p>
                        <p class="profile-email">
                          {{ userProfile.profileIdentifiers[0].emailId }}
                        </p>
                      </div>
                    </div>
                  </li>

                  <li><hr class="dropdown-divider" /></li>

                  <!-- These still close the dropdown -->
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="routeLink.myAccount"
                      [routerLinkActive]="['active']"
                    >
                      <i class="bi bi-person-gear text-lg"></i>
                      <span>Account Settings</span>
                    </a>
                  </li>
                  <!-- @if(subscribed) {
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="routeLink.upgrade"
                      [routerLinkActive]="['active']"
                    >
                      <i class="bi bi-gem text-lg"></i>
                      <span>Upgrade subscription</span>
                    </a>
                  </li>
                  } -->
                  <!-- <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="routeLink.helpCenter"
                      [routerLinkActive]="['active']"
                    >
                      <i class="fa-regular fa-circle-question text-lg"></i>
                      <span>Help Center</span>
                    </a>
                  </li> -->
                  <li><hr class="dropdown-divider" /></li>
                  <li>
                    <a
                      class="dropdown-item-logout"
                      href="javascript:void(0)"
                      (click)="logout(); $event.preventDefault()"
                    >
                      <i class="bi bi-power text-lg"></i>
                      Logout</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      }
    </nav>
  </div>
</div>
